import { isValid, parse } from 'date-fns';

/**
 * Parses an ISO date-only string in `YYYY-MM-DD` or `YYYY-MM-DD HH:MM:SS` format.
 * Returns `null` when the input is missing or invalid.
 */
export const parseCalendarDate = (value?: string): Date | null => {
  if (!value || !/^\d{4}-\d{2}-\d{2}(?: \d{2}:\d{2}:\d{2})?$/.test(value)) {
    return null;
  }

  const dateString = value.slice(0, 10);
  const parsed = parse(dateString, 'yyyy-MM-dd', new Date());
  return isValid(parsed) ? parsed : null;
};
